module.exports = __webpack_public_path__ + "img/loading.a227cbe6.svg";